import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import CommonBreadcrumb from "./../../common_components/breadcrumb/CommonBreadcrumb";
import { useState } from "react";
import TrackShipment from "./../../common_components/common_modal/track_shipmment/TrackShipmment";
import { Button } from "react-bootstrap";
import "./OrderHistory.css";
import { getAllOrder } from "../../../features/admin/product/productdetails/Slice";
import { useDispatch, useSelector } from "react-redux";
import { AllOrderStatus } from "../../../features/admin/common/Slice";
const OrderHistory = () => {
  const dispatch = useDispatch();
  const productsdetails = useSelector(
    (state) => state.product.productdetails?.get_order_history,
  );
  const all_order_status = useSelector(
    (state) => state?.common?.all_order_status,
  );

  const [selectedStatus, setSelectedStatus] = useState(null);

  useEffect(() => {
    dispatch(getAllOrder());
    dispatch(AllOrderStatus());
  }, [dispatch]);
  const breadcrumbItems = [
    { label: "Profile", link: "/profile" },
    { label: "Order History" },
  ];

  const [showModal, setShowModal] = useState(false);

  const handleOpen = (statusId) => {
    setSelectedStatus(statusId);
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);

  return (
    <section className="order-plased-section order-history">
      <CommonBreadcrumb items={breadcrumbItems} />

      <Container className="py-5 conatiner-section">
        <Row className="g-4 card-row justify-content-center">
          {productsdetails?.map((order, index) => (
            <Col  xs={12} md={12} lg={5} key={index} className="mb-5">
              <Card className="card-one p-3 shadow-sm border-0 rounded-4 h-100">
                <div className="succes-order">
                  <h6>
                    <img src="/images/profile/checked.png" alt="not" />
                    Order Confirmed
                  </h6>
                  <p
                    className="track-shipment-navigation"
                    onClick={() => handleOpen(order?.order_status_id)}
                  >
                    Track Shipmment
                  </p>
                </div>

                <div className="d-flex justify-content-between small text-muted">
                  <div className="order">
                    <span> Order Number </span>
                    <strong># {order?.order_number}</strong>
                  </div>

                  <div className="order order-date">
                    <span> Order Date </span>
                    <strong>
                      {new Date(order?.created_at).toLocaleDateString("en-US", {
                        month: "short",
                        day: "2-digit",
                        year: "numeric",
                      })}
                    </strong>
                  </div>
                </div>

                <div className="product-box">
                  <div className="d-flex product-card align-items-center">
                    <img src="/images/cart/productImg.png" alt="product" />
                    <div className="product-details">
                      <h6>{order?.order_details?.[0]?.product?.name}</h6>
                      <p>{order?.order_details?.[0]?.product?.description}</p>
                      <span>
                        {order?.order_details?.[0]?.product?.power} -{" "}
                        {order?.order_details?.[0]?.quantity}
                        Capsules
                      </span>
                    </div>
                  </div>
                </div>

                <div className="price-section">
                  <div className="price-row">
                    <span>Subtotal</span>
                    <span className="price-rs">₹. {order?.sub_total}/-</span>
                  </div>

                  <div className="price-row">
                    <span>Standard Shipping</span>
                    <span className="price-rs">
                      ₹. {order?.shipping_charges}/-
                    </span>
                  </div>
                  {/* 
                  <div className="price-row">
                    <span>Estimated Tax</span>
                    <span className="price-rs">₹. 10</span>
                  </div> */}

                  <div className="price-row">
                    <span>Grand Total</span>
                    <span className="price-rs">₹. {order?.grand_total}/-</span>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      <TrackShipment
        show={showModal}
        handleClose={handleClose}
        orderStatusId={selectedStatus}
        allStatus={all_order_status}
      />
    </section>
  );
};

export default OrderHistory;
